<div [hidden]="!activeStep">
    <ng-content></ng-content>
</div>
